import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import { GetPermListForRole } from 'data/permData';
import GetWidgetData from 'data/widgetData/widgetData.js';
import { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetAllAvailableDeviceTypesQuery } from 'services/devices/devices.api';
import { getWorkplaceMembers } from 'services/organization/organization.service';
import { getGlobalWidgetPermList } from 'services/perms/perms.service';
import { getRole, updateRole } from 'services/roles/roles.service';
import { getVisibleUsers } from 'utils/roleUtils';
import '../Dashboard/assets/Dashboard.css';
import DashboardEditTab from './Components/DashboardEditTab';
import DashboardViewTab from './Components/DashboardViewTab';
import DetailsTab from './Components/DetailsTab';
import PermissionsTab from './Components/PermissionsTab';

const TAB_OPTIONS = ['Role Details', 'Permissions', 'Dashboard Edit', 'Dashboard View'];

const normalizeDeviceTypes = (payload) => {
  if (!payload || typeof payload !== 'object') return {};

  if (payload.status === 200 && payload.data?.result && typeof payload.data.result === 'object') {
    return payload.data.result;
  }

  if (payload.result && typeof payload.result === 'object' && !Array.isArray(payload.result)) {
    return payload.result;
  }

  return payload;
};

export default function EditRole() {
  const navigate = useNavigate();
  const [widgetData, setWidgetData] = useState(GetWidgetData());
  const perms = usePerms();
  const {
    data: deviceTypeRes,
    isLoading: deviceTypesLoading,
    isError: deviceTypesError,
  } = useGetAllAvailableDeviceTypesQuery();

  const [permList, setPermList] = useState([]);
  const [params, setParams] = useSearchParams();
  const [formData, setFormData] = useState({
    roleName: '',
    members: [],
    initialMembers: [],
    permissions: permList.map(() => true),
    layout: [],
  });
  const [checks, setChecks] = useState({ roleName: true });
  const [result, setResult] = useState('');
  const [membersList, setMembersList] = useState([]);

  useEffect(() => {
    (async () => {
      if (deviceTypesLoading) return;

      let permList = [];

      const deviceTypeData = normalizeDeviceTypes(deviceTypeRes);

      const deviceTypeArr = Object.keys(deviceTypeData).flatMap((systemType) => {
        const systemTypeMap = deviceTypeData[systemType] || {};
        return Object.keys(systemTypeMap).flatMap((deviceType) => {
          const deviceTypeMap = systemTypeMap[deviceType] || {};
          if (
            Object.keys(deviceTypeMap).length > 0 &&
            !Object.keys(deviceTypeMap).includes('validDevices')
          )
            return Object.keys(deviceTypeMap).map(
              (subType) => systemType + ' ' + deviceType + '_' + subType,
            );
          else return systemType + ' ' + deviceType;
        });
      });

      const globalWidgetPermList = (await getGlobalWidgetPermList()).data.result;

      const newPerms = GetPermListForRole(deviceTypeArr).map((perm, index) => ({
        ...perm,
        originalIndex: index,
        originalLinked: perm.linked || 0,
        originalEnableLinked: perm.enableLinked || 0,
      }));

      const filteredPerms = newPerms.filter((filter, index) => {
        if (filter.linked > 0) {
          if (!newPerms[index + 1]) return false;
          return globalWidgetPermList.permissions.includes(
            newPerms[index + 1].name.replace(/\s/g, '').replace(/\//g, '-').replace(/:/g, '_'),
          );
        } else {
          return globalWidgetPermList.permissions.includes(
            filter.name.replace(/\s/g, '').replace(/\//g, '-').replace(/:/g, '_'),
          );
        }
      });

      const getRemainingLinkedCount = (perm, rangeLength) => {
        if (!rangeLength) return 0;
        const start = perm.originalIndex;
        const end = perm.originalIndex + rangeLength;
        return filteredPerms.reduce((count, item) => {
          if (item.originalIndex > start && item.originalIndex <= end) return count + 1;
          return count;
        }, 0);
      };

      permList = filteredPerms.map((perm, index) => ({
        ...perm,
        linked: getRemainingLinkedCount(perm, perm.originalLinked),
        enableLinked: perm.originalEnableLinked
          ? getRemainingLinkedCount(perm, perm.originalEnableLinked)
          : perm.enableLinked,
        index,
      }));

      setPermList([...permList]);

      const allWidgetData = GetWidgetData();
      let newWidgetList = {};
      Object.keys(allWidgetData).forEach((key) => {
        if (globalWidgetPermList.widgetList.includes(parseInt(key))) {
          newWidgetList = { ...newWidgetList, [key]: allWidgetData[key] };
        }
      });

      setWidgetData(newWidgetList);

      const userData = await getWorkplaceMembers(getVisibleUsers(perms)).then((res) => {
        const temp = [...res.data.result];
        temp.map((item) => (item = { ...item, selected: false }));
        return [...temp];
      });

      await getRole(params.get('roleid')).then((result) => {
        const parsedPerms = JSON.parse(result.data.result[0].role_perms);

        const permissions = permList.map(() => false);

        Object.keys(parsedPerms).map((key) => {
          const str = parsePermName(key);
          const index = permList.findIndex((item) => item.name === str);

          // console.log(
          //   'Permission:',
          //   key,
          //   'or',
          //   str,
          //   '(i =',
          //   index,
          //   ') =',
          //   parsedPerms,
          //   '=>',
          //   parsedPerms[key]
          // );

          permissions[index] = parsedPerms[key];
        });

        const initUsers = [];
        const temp = [];

        for (let i = 0; i < userData.length; i++) {
          const userRoles = JSON.parse(userData[i].roles);
          if (userRoles.includes(parseInt(params.get('roleid')))) {
            initUsers.push({ ...userData[i] });
            temp.push({ ...userData[i], selected: true });
          } else {
            temp.push({ ...userData[i] });
          }
        }

        setMembersList([...temp]);
        setFormData((prev) => ({
          ...prev,
          roleName: result.data.result[0].role_name,
          permissions: [...permissions],
          initialMembers: [...initUsers],
          layout: JSON.parse(result.data.result[0].widget_list),
        }));
      });
    })();
  }, [deviceTypeRes, deviceTypesLoading]);

  const getCurrentTabIndex = () => {
    const tabParam = params.get('tab');
    const matchedIndex = TAB_OPTIONS.findIndex(
      (option) => option.toLowerCase() === tabParam?.toLowerCase(),
    );
    return matchedIndex === -1 ? 0 : matchedIndex;
  };

  const currentTabIndex = getCurrentTabIndex();

  const updateTabParam = (nextIndex, replace = false) => {
    const newParams = new URLSearchParams(params.toString());
    newParams.set('tab', TAB_OPTIONS[nextIndex]);
    setParams(newParams, { replace });
  };

  const renderTab = () => {
    if (!perms.testPermission([8, 9, 10, 11, 12, 13], ['EditRole'])) return;

    switch (currentTabIndex) {
      case 0:
        return (
          <DetailsTab
            formData={formData}
            setFormData={setFormData}
            checks={checks}
            membersList={membersList}
            setMembersList={setMembersList}
            widgetData={widgetData}
            permList={permList}
            roleid={params.get('roleid')}
          />
        );
      case 1:
        return (
          <PermissionsTab
            formData={formData}
            setFormData={setFormData}
            checks={checks}
            widgetData={widgetData}
            permList={permList}
            roleid={params.get('roleid')}
          />
        );
      case 2:
        if (!perms.testPermission([8, 9, 10, 11, 12, 13], ['EditRoleDashboard'])) return;
        return (
          <DashboardEditTab
            formData={formData}
            setFormData={setFormData}
            checks={checks}
            widgetData={widgetData}
            permList={permList}
            compactPreview
          />
        );
      case 3:
        if (!perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAsRole'])) return;
        return (
          <DashboardViewTab
            formData={formData}
            setFormData={setFormData}
            checks={checks}
            widgetData={widgetData}
            permList={permList}
            compactPreview
          />
        );
      default:
        return (
          <DetailsTab
            formData={formData}
            setFormData={setFormData}
            checks={checks}
            membersList={membersList}
            setMembersList={setMembersList}
            widgetData={widgetData}
            permList={permList}
            roleid={params.get('roleid')}
          />
        );
    }
  };

  const onSubmit = () => {
    let permissions = {};

    formData.permissions.forEach((perm, index) => {
      const permName = permList[index].name
        .replace(/\s/g, '')
        .replace(/\//g, '-')
        .replace(/:/g, '_');
      permissions = { ...permissions, [permName]: perm };
    });

    const members = membersList
      .filter((filter) => {
        let msList = [];
        if (filter.msRoles) msList = JSON.parse(filter.msRoles);
        return filter.selected && !msList.includes(parseInt(params.get('roleid')));
      })
      .map((member) => {
        return member.userId;
      });

    updateRole(
      params.get('roleid'),
      formData.roleName,
      members,
      JSON.stringify(permissions),
      JSON.stringify(formData.layout),
    )
      .then((res) => {
        setResult({ type: 'success', message: 'Role created successfully' });
        navigate('/system/rolemanager');
      })
      .catch((e) => {
        setResult({
          type: 'failed',
          message: 'Failed: ' + e.response.data.message,
        });
      });
  };

  const parsePermName = (permName) => {
    let str = permName
      .replace(/-/g, '/')
      .replace(/_/g, permName.includes('TechnologyBridge') ? '_' : ':');

    // Protect USGS from being split into 'U S G S'
    let restoreUSGS = false;
    if (str.includes('USGS')) {
      str = str.replace(/USGS/g, 'Usgs');
      restoreUSGS = true;
    }

    let characters = str.split('');
    let result = [];

    characters.forEach((char, index) => {
      if (
        char === char.toUpperCase() &&
        index > 0 &&
        !(char === 'I' && characters[index - 1] === 'A') &&
        //RescAlert
        !(char === 'A' && characters[index - 1] === 'c') &&
        //AWARE
        !(char === 'W' && characters[index - 1] === 'A') &&
        !(char === 'A' && characters[index - 1] === 'W') &&
        !(char === 'R' && characters[index - 1] === 'A') &&
        !(char === 'E' && characters[index - 1] === 'R') &&
        //VMS
        !(char === 'M' && characters[index - 1] === 'V') &&
        !(char === 'S' && characters[index - 1] === 'M')
      ) {
        result.push(' ');
      }
      result.push(char);
    });

    str = result.join('');

    if (restoreUSGS) str = str.replace(/Usgs/g, 'USGS'); //Restore USGS if it was changed
    str = str.replace(' _ ', '_').replace('Siren / Giant', 'Siren/Giant');
    return str;
  };

  const onClose = () => {
    navigate('/system/rolemanager');
  };

  const onSubmitClick = () => {
    const roleNameValid = formData.roleName !== '';
    setChecks({ roleName: roleNameValid });
    if (roleNameValid) {
      onSubmit();
    }
  };

  const onBack = () => {
    if (currentTabIndex === 0) onClose();
    else updateTabParam(currentTabIndex - 1);
  };

  const onNext = () => {
    if (currentTabIndex === TAB_OPTIONS.length - 1) {
      onSubmitClick();
    } else {
      updateTabParam(currentTabIndex + 1);
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100">
      <div className="d-flex flex-row justify-content-between mt-2 flex-shrink-0">
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onBack}
        >
          <div className="d-flex align-items-center">
            <IconContext.Provider value={{ size: 20 }}>
              <FaChevronLeft />
            </IconContext.Provider>
          </div>
          <div className="me-1 fs-6 gap-2">{currentTabIndex === 0 ? 'Return' : 'Back'}</div>
        </Button>
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onNext}
        >
          <div className="ms-1 fs-6 gap-2">
            {currentTabIndex === TAB_OPTIONS.length - 1 ? 'Submit' : 'Next'}
          </div>
          {currentTabIndex !== TAB_OPTIONS.length - 1 && (
            <div className="d-flex align-items-center">
              <IconContext.Provider value={{ size: 20 }}>
                <FaChevronRight />
              </IconContext.Provider>
            </div>
          )}
        </Button>
      </div>
      <div className="mt-2 d-none d-lg-block flex-shrink-0">
        <TabsHeader
          currentTabs={[currentTabIndex]}
          onTabChange={(newTab) => updateTabParam(newTab[0])}
          options={TAB_OPTIONS.map((option) => ({ option }))}
        />
      </div>
      <div className="mt-3 d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader options={TAB_OPTIONS.map((option) => ({ option }))} />
      </div>
      <div className="d-flex flex-column flex-grow-1 overflow-hidden mt-3" style={{ minHeight: 0 }}>
        <div className="d-flex bg-base flex-grow-1 overflow-hidden" style={{ minHeight: 0 }}>
          {renderTab()}
        </div>
      </div>
      {result && (
        <div
          className="h4 fw-bold flex-shrink-0"
          style={{ color: result.type === 'success' ? 'green' : 'red' }}
        >
          {result.message}
        </div>
      )}
    </Container>
  );
}
